import type { CreditMemoColumn } from './CreditMemosTable.types';

export const TABLE_COLUMNS: CreditMemoColumn[] = [
  {
    id: 'creditMemoNumber',
    label: 'Transaction ID',
    width: '10.5rem',
  },
  {
    id: 'appliedOn',
    label: 'Applied on',
    width: '10.5rem',
  },
  {
    id: 'amount',
    label: 'Amount',
    width: '10.5rem',
  },
  {
    id: 'download',
    label: '',
    ariaLabel: 'Actions',
    width: '4.5rem',
  },
];
